import request from "./../utils/request";

export function getWhatsappSS() {
    return request.get("/whatsapp/ss");
}
